module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loader', {
    attrs: {
      "label": "Carregando contas..."
    }
  }) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "columns": 12,
      "label": "Conta",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-select",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.account = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.sheinAccounts), function(account) {
    return _c('option', {
      key: account.identifier,
      domProps: {
        "value": account.identifier
      }
    }, [_vm._v("\n        " + _vm._s(account.nickname) + "\n      ")])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05de8124","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shein/order/SyncDialog.vue
// module id = 2879
// module chunks = 0